// 底部导航栏管理
import http from "@/jslibs/axios/http";

// 底部导航栏列表
export const list = (data) => http.get("/v1/cms/bottomnav", data);

// 底部导航栏新增
export const add = (data) => http.post("/v1/cms/bottomnav", data);

// 底部导航栏编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/bottomnav/${uuid}`, data);

// 底部导航栏删除
export const del = ({ uuid }) => http.delete(`/v1/cms/bottomnav/${uuid}`);

// 底部导航栏详情
export const detail = ({ uuid }) => http.get(`/v1/cms/bottomnav/${uuid}`);